import { BsFacebook, BsInstagram, BsLinkedin, BsTwitter } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import classes from "./FooterStyles.module.css";

const EXPLORE_LINKS = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Blog", to: "/blog" },
  { label: "Contact", to: "/contact" },
];

const SERVICES = ["Ride Booking", "Gift Cards", "Bills Payment", "Dispatch Delivery", "Event Tickets"];

const SOCIAL_LINKS = [
  { href: "https://web.facebook.com/sprinterwave", label: "Facebook", Icon: BsFacebook },
  { href: "https://twitter.com/thesprinterwave", label: "Twitter", Icon: BsTwitter },
  { href: "https://www.instagram.com/sprinterwave/", label: "Instagram", Icon: BsInstagram },
  { href: "https://www.linkedin.com/company/sprinterwave/", label: "LinkedIn", Icon: BsLinkedin },
];

const Footer = () => {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  return (
    <footer className={classes.footer}>
      <div className={classes.top}>
        <div className={classes.brandCol}>
          <div className={classes.logoWrapper} onClick={() => navigate("/")}>
            <img className={classes.logoImg} src="/sprinter.png" alt="Sprinterwave logo" />
            <h3 className={classes.logoText}>Sprinterwave</h3>
          </div>
          <p className={classes.tagline}>
            Rides, bill payments, gift cards, dispatch delivery, and event
            tickets, all in one app.
          </p>

          <div className={classes.socials}>
            {SOCIAL_LINKS.map(({ href, label, Icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className={classes.socialIcon}
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        <div className={classes.linkCol}>
          <h4>Explore</h4>
          <ul>
            {EXPLORE_LINKS.map((link) => (
              <li key={link.to}>
                <Link to={link.to}>{link.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div className={classes.linkCol}>
          <h4>Services</h4>
          <ul>
            {SERVICES.map((service) => (
              <li key={service}>
                <span>{service}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className={classes.linkCol}>
          <h4>Legal</h4>
          <ul>
            <li>
              <Link to="/terms-and-conditions">Terms and Conditions</Link>
            </li>
            <li>
              <Link to="/privacy-policy">Privacy Policy</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className={classes.bottomBar}>
        <p>© {year} Sprinterwave. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;